export const money = (cents, symbol = "$") => {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return "";
  const neg = cents < 0; const c = Math.abs(Math.round(cents));
  return `${neg ? "-" : ""}${symbol}${Math.floor(c / 100).toLocaleString("en-US")}.${String(c % 100).padStart(2, "0")}`;
};
export const moneyOrPending = (cents, zh) => (cents === null || cents === undefined ? (zh ? "待补全" : "Pending") : money(cents));

export const toCents = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "number") return Math.round(v * 100);
  const s = String(v).replace(/[^\d.\-]/g, "");
  if (!s || s === "-" || s === "." || s === "-.") return null;
  const n = parseFloat(s);
  return Number.isNaN(n) ? null : Math.round(n * 100);
};
export const centsToInput = (c) => (c === null || c === undefined ? "" : (c / 100).toFixed(2));
export const numOrNull = (v) => { if (v === null || v === undefined || v === "") return null; const n = parseFloat(String(v).replace(/,/g, "")); return Number.isNaN(n) ? null : n; };
export const fmtQty = (q) => { const f = Number(q); if (Number.isNaN(f)) return String(q ?? ""); return Math.abs(f - Math.round(f)) < 1e-9 ? f.toLocaleString("en-US") : f.toLocaleString("en-US", { maximumFractionDigits: 2 }); };

export const SRC_STYLE = {
  lead: "bg-sky-50 text-sky-700 border-sky-200",
  intake: "bg-teal-50 text-teal-700 border-teal-200",
  estimate: "bg-violet-50 text-violet-700 border-violet-200",
  concept: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  template: "bg-slate-100 text-slate-600 border-slate-200",
  system: "bg-slate-100 text-slate-600 border-slate-200",
  manual: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-red-50 text-red-700 border-red-200",
};

export const STATUS_LABEL = { none: ["未创建", "None"], draft: ["草稿", "Draft"], sent: ["已发送", "Sent"], signed: ["已签署", "Signed"] };
export const KIND_LABEL = { draft: ["草稿", "Draft"], reimport: ["重新带入", "Re-import"], signed: ["签署版", "Signed"], addendum: ["补充协议", "Addendum"] };

const pctCents = (basis, pct) => Math.round((basis * pct) / 100);

/** 与服务端 compute_ws 同口径的即时重算 (整数分); 服务端保存后以其返回为准。 */
export function computeLocal(ws, template) {
  const spec = { ...(ws.spec || {}) };
  const sf = numOrNull(spec.sf);
  const unit = spec.unitPriceCents ?? null;
  const fee = spec.feeCents ?? null;
  spec.baseCents = fee !== null ? fee : (sf && unit !== null ? Math.round(sf * unit) : null);
  let add = 0, ded = 0, gift = 0, pendingItems = 0;
  const items = (ws.items || []).map((it) => {
    const o = { ...it };
    if (o.unit === "sf" && numOrNull(o.qty) && o.unitPriceCents !== null && o.unitPriceCents !== undefined) o.amountCents = Math.round(numOrNull(o.qty) * o.unitPriceCents);
    if (o.kind === "gift") o.amountCents = 0;
    else if (o.amountCents !== null && o.amountCents !== undefined) o.amountCents = Math.abs(o.amountCents);
    if (!(o.nameEn || o.nameZh)) return o;
    if (o.kind === "addition") { if (o.amountCents === null || o.amountCents === undefined) pendingItems += 1; else add += o.amountCents; }
    else if (o.kind === "deduction") { if (o.amountCents === null || o.amountCents === undefined) pendingItems += 1; else ded += o.amountCents; }
    else gift += o.valueCents || 0;
    return o;
  });
  const total = spec.baseCents !== null ? spec.baseCents + add - ded : null;
  const tplRows = Object.fromEntries((template?.payments || []).map((r) => [r.key, r]));
  const rowsIn = ws.paymentRows?.length ? ws.paymentRows : (template?.payments || []).map((r) => ({ ...r }));
  const rows = rowsIn.map((r, i) => {
    const base = tplRows[r.key] || {};
    const pct = "pct" in r ? numOrNull(r.pct) : base.pct;
    const row = { ...r, no: i + 1, pct: pct || null, pctBase: r.pctBase || base.pctBase || null, deductionCents: r.deductionCents || 0 };
    row.triggerEdited = !!r.triggerEdited || (!!base.key && (r.triggerEn || "") !== (base.triggerEn || ""));
    row.docEdited = !!r.docEdited || (!!base.key && (r.docEn || "") !== (base.docEn || ""));
    return row;
  });
  let fixedSum = 0;
  rows.forEach((r) => { if (r.override) fixedSum += r.amountCents || 0; else if (!r.pct && r.fixedCents !== null && r.fixedCents !== undefined) fixedSum += r.fixedCents; });
  rows.forEach((r) => {
    if (r.override) return;
    if (r.pct && total !== null) { const basis = r.pctBase === "remaining" ? total - fixedSum : total; r.amountCents = pctCents(basis, r.pct) - (r.deductionCents || 0); }
    else if (r.pct) r.amountCents = null;
    else r.amountCents = r.fixedCents ?? null;
  });
  const sum = rows.reduce((t, r) => t + (r.amountCents ?? 0), 0);
  return { ...ws, spec, items, paymentRows: rows, totalCents: total, paymentSumCents: sum, paymentDiffCents: total === null ? null : sum - total,
    paymentPending: rows.filter((r) => r.amountCents === null || r.amountCents === undefined).length,
    pricing: { baseCents: spec.baseCents, additionsCents: add, deductionsCents: ded, giftsValueCents: gift, pendingItems, totalCents: total } };
}
